import { useEffect } from 'react';

import { useFormDataQuery } from '@/api/getters';
import { Stages } from '@/api/types';
import ClientCardHH from '@/features/v2/hh/components/layout/ClientCardHH';
import { useStepper } from '@/features/v2/lib/stepper';
import { FormComponent, Stepper } from '@/features/v2/lib/wizard';
import { PRODUCT_DATA } from '@/features/v2/product-data';
import cn from '@/utils/cn';

const HouseHold = () => {
  const { data } = useFormDataQuery();
  const { step, setStep } = useStepper();

  // TODO: do it better (edge case handler)
  useEffect(() => {
    // in order to fix the bug with the step on the stage finished
    if (data?.stage === Stages.FINISHED && step < 3) {
      setStep(3);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.stage === Stages.FINISHED]);

  if (!data) return null;

  const StageComponent =
    PRODUCT_DATA[data.product.id].stages[data.stage].component;
  const progress = PRODUCT_DATA[data.product.id].stages[data.stage].progress;

  const displayProgressBar =
    progress &&
    !(
      data.stage === Stages.CONTACT_US &&
      (data?.offer?.offer_rejected === true ||
        data?.offer?.offer_rejected === false) &&
      !data.offer.is_complementary
    );

  const isOfferPage =
    data.stage === Stages.OFFER || data.stage === Stages.OFFER_FINISHED;

  return (
    <>
      <ClientCardHH className="hidden lg:flex" isOfferPage={isOfferPage} />
      <div className={'w-full lg:flex lg:gap-x-5'}>
        <div
          className={cn(
            'flex flex-col lg:w-[670px] lg:gap-y-5',
            !displayProgressBar && 'lg:w-full'
          )}
        >
          {StageComponent ? StageComponent : <FormComponent />}
        </div>
        {displayProgressBar && (
          <div>
            <Stepper progressType={progress} />
          </div>
        )}
      </div>
    </>
  );
};

export default HouseHold;
